<div class="fullscreen-dialog">
  <div class="dialog-header">
    <app-dialog-header titleTranslateKey="{{ resource.name }}" (closeClicked)="onCancelClick()" >
    </app-dialog-header>
  </div>

<mat-dialog-content>
  <p style="font-weight: bolder;
    text-align: center;">Route
    for {{ data.dateFrom | amDateFormat: 'DD/MM/YYYY HH:mm' }} {{ data.dateTo | amDateFormat: 'DD/MM/YYYY HH:mm' }}</p>
  <div class="map-panel">
    <div class="map" id="map"></div>
    <div class="directions-accordion">
      @for (detail of resourceScheduleDetails; track detail) {
        <mat-accordion>
          <mat-expansion-panel [ngClass]="'ticket-expansion-panel'">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div [style.background-color]="detail.background" [style.foreground-color]="detail.foreground"
                class="traffic-light"></div>
                {{ detail.ticket.ticketStatus }} -
                {{ detail.ticket.visit.job.externalJobReference }}
              </mat-panel-title>
              <mat-panel-description>
                Leave  {{ detail.ticket.enrouteTime | amDateFormat: 'HH:mm' }} /
                Arrive {{ detail.ticket.arrivedTime | amDateFormat: 'HH:mm' }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            Directions
            @if (detail.route) {
              <mat-list>
                @for (instruction of detail.route.instructions; track instruction) {
                  <mat-list-item>{{ instruction.distance }}
                    m {{ instruction.signDescription }} {{ instruction.name }} ({{ instruction.time }}s)
                  </mat-list-item>
                }
              </mat-list>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }

    </div>
  </div>
</mat-dialog-content>
  </div>
